export default __webpack_public_path__ + "static/media/close.18719990.svg";